import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Pixel/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/material-icons.css");
